import { createDirectionalZoneDetector } from "./zoneShared";

export const detectSupplyZones = createDirectionalZoneDetector({
  zoneName: "supply",
  zoneLabel: "Supply",
  isDemand: false,
});
